import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

export default function useCustomerSocket(token, handlers = {}) {
  const [state, setState] = useState("idle");
  const handlersRef = useRef(handlers);

  useEffect(() => {
    handlersRef.current = handlers;
  }, [handlers]);

  useEffect(() => {
    if (!token) {
      setState("idle");
      return undefined;
    }

    const baseUrl = import.meta.env.VITE_API_URL || window.location.origin;
    const socket = io(`${baseUrl}/customer`, {
      path: "/socket.io",
      auth: { token },
      transports: ["polling"],
      upgrade: false,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 30000
    });

    setState("connecting");
    socket.on("connect", () => setState("connected"));
    socket.on("disconnect", () => setState("disconnected"));
    socket.on("connect_error", () => setState("error"));
    socket.on("joined", (payload) => handlersRef.current.onJoined?.(payload));
    socket.on("order:created", (payload) => handlersRef.current.onOrderCreated?.(payload));
    socket.on("order:status_changed", (payload) => handlersRef.current.onOrderStatusChanged?.(payload));
    socket.on("invoice:issued", (payload) => handlersRef.current.onInvoiceIssued?.(payload));
    socket.on("invoice:cancelled", (payload) => handlersRef.current.onInvoiceCancelled?.(payload));
    socket.on("table:session_closed", (payload) => handlersRef.current.onSessionClosed?.(payload));
    socket.on("table:session_opened", (payload) => handlersRef.current.onSessionOpened?.(payload));

    return () => socket.close();
  }, [token]);

  return state;
}
